import { render, staticRenderFns } from "./CidadaoLayout.vue?vue&type=template&id=794d9aa8&"
import script from "./CidadaoLayout.vue?vue&type=script&lang=js&"
export * from "./CidadaoLayout.vue?vue&type=script&lang=js&"
import style0 from "./CidadaoLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports